import React, { useContext, useCallback } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Link } from "../link";
import ButtonWTB from "./button-wtb";
import { hasEcommerce } from "../../utility/ecommerce";
import useReevooTrack from "../../hooks/use-reevoo-track";
import useWhereToBuy from "../../hooks/use-where-to-buy";
import useStoreLocator from "../../hooks/use-store-locator";
import CartContext from "../../context/cart";
import PdpWidgetPrice from "./pdp-widget-price";
import CartIcon from "../../icons/carrello.svg";

const externalPDPShopify = process.env.GATSBY_SHOPIFY_EXTERNAL_PDP || false;

const PdpTopActions = ({ data, priceData, contributoRaee, location, storeLink }) => {
  const { key_prod: productId, assetId } = data;
  const {
    config: { wtbAndRetailersActive },
    labelManagerLabels,
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        wtbAndRetailersActive
      }
      labelManagerLabels {
        addToCart
        buyOnHaierShop
        buyNow
        whereToBuy
      }
    }
  `);
  const { addProduct, adding, loadingCart } = useContext(CartContext);
  const addToCart = useCallback(
    () => addProduct(data, priceData, location, "PDP - Sticky Top"),
    [addProduct, data, priceData, location]
  );
  const reevooTrack = useReevooTrack(productId);
  const whereToBuyAssetId = useWhereToBuy(assetId);
  const storeLocatorPage = useStoreLocator();

  const enabledForLine = [undefined, "[]"].includes(
    data.pageLine?.lineConfigurationFieldSet?.isNotEcommerce?.[0]
  );
  const ecommerceActive = hasEcommerce && enabledForLine;

  const shopLink = priceData?.shopLink || data?.shopLink;

  return ecommerceActive || (priceData && (enabledForLine || priceData.shopLink)) || shopLink ? (
    <>
      <div>
        {enabledForLine && <PdpWidgetPrice priceData={priceData} contributoRaee={contributoRaee} />}
      </div>
      <div className={priceData === undefined ? "product-detail__hide" : "d-flex align-items-end"}>
        {ecommerceActive && priceData?.sellingPrice?.value && !externalPDPShopify ? (
          <button
            className="product-detail__addcart"
            onClick={addToCart}
            disabled={adding || loadingCart}
          >
            <CartIcon className="icon-svg-detail" />
            {labelManagerLabels.addToCart}
          </button>
        ) : shopLink && externalPDPShopify ? (
          <a href={shopLink} target="_blank" rel="noreferrer" className="product-detail__addcart">
            <CartIcon className="icon-svg-detail" />
            {labelManagerLabels.buyOnHaierShop}
          </a>
        ) : ecommerceActive && priceData === null ? (
          <span className="product-detail__addcart product-detail__hide">
            {labelManagerLabels.addToCart}
          </span>
        ) : (
          <span className="product-detail__addcart product-detail__hide">
            <CartIcon className="icon-svg-detail" />
            {labelManagerLabels.buyOnHaierShop}
          </span>
        )}
        {((!priceData?.sellingPrice?.value && !shopLink) ||
          (!!priceData?.sellingPrice?.value &&
            hasEcommerce &&
            wtbAndRetailersActive &&
            !!wtbAndRetailersActive?.length)) &&
          (whereToBuyAssetId ? (
            <ButtonWTB
              className={`btn-link btn-link--blue cswidget${
                priceData ? " product-detail__hide" : ""
              }`}
              label={labelManagerLabels.whereToBuy}
              reevooTrack={reevooTrack}
              sku={productId}
              assetId={whereToBuyAssetId}
              location={location}
              storeLink={storeLink}
            />
          ) : (
            storeLocatorPage && (
              <Link
                to={!!storeLink ? storeLink : storeLocatorPage}
                target={!!storeLink ? "_blank" : "_self"}
                className={`btn-link btn-link--blue ${priceData ? " product-detail__hide" : ""}`}
                rel="noreferrer"
              >
                {labelManagerLabels.whereToBuy}
              </Link>
            )
          ))}
      </div>
    </>
  ) : whereToBuyAssetId ? (
    <ButtonWTB
      className="product-detail__addcart cswidget"
      label={labelManagerLabels.whereToBuy}
      reevooTrack={reevooTrack}
      sku={productId}
      assetId={whereToBuyAssetId}
      location={location}
      storeLink={storeLink}
    />
  ) : storeLocatorPage ? (
    <Link
      to={!!storeLink ? storeLink : storeLocatorPage}
      target={!!storeLink ? "_blank" : "_self"}
      className="product-detail__addcart"
      rel="noreferrer"
    >
      {labelManagerLabels.buyNow}
    </Link>
  ) : null;
};

export default PdpTopActions;
